<template>
  <slot v-if="isAllowed"></slot>
  <slot v-else name="fallback"></slot>
</template>

<script>
import { computed } from 'vue';
import { hasPermission, hasAnyPermission, hasAllPermissions } from '@/utils/permissions';

export default {
  name: 'PermissionGuard',
  props: {
    // Single permission string or array of permissions
    permission: {
      type: [String, Array],
      required: true
    },
    // Whether to require all permissions (when array is provided)
    // If false (default), will check if user has any of the permissions
    requireAll: {
      type: Boolean,
      default: false
    },
    // Whether to invert the check logic (hide if has permission)
    not: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const isAllowed = computed(() => {
      let hasRequired;

      if (Array.isArray(props.permission)) {
        hasRequired = props.requireAll
          ? hasAllPermissions(props.permission)
          : hasAnyPermission(props.permission);
      } else {
        hasRequired = hasPermission(props.permission);
      }

      // If 'not' prop is true, invert the result
      return props.not ? !hasRequired : hasRequired;
    });

    return {
      isAllowed
    };
  }
};
</script>
